package org.hs_soft.runmynesto.pages.components.menu

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.menu.MenuItemsEnum
import org.hs_soft.runmynesto.domain.model.menu.MenuModel
import org.hs_soft.runmynesto.domain.util.Constants
import org.hs_soft.runmynesto.domain.util.animatedWidth
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun Menu(
    data: MenuModel,
    isMenuExpandedHorizontally: Boolean,
    windowSizeMode: WindowSizeModeEnum,
    selectedItem: MenuItemsEnum,
    closeMenu: () -> Unit,
    changeMenuStatus: () -> Unit,
    onMenuItemClick: (MenuItemsEnum) -> Unit,
    content: @Composable () -> Unit,
)
{
    var isFirstRender by remember { mutableStateOf(true) }

    LaunchedEffect(isMenuExpandedHorizontally) {
        if (isMenuExpandedHorizontally)
            isFirstRender = false
    }



    Box(
        modifier = Modifier
            .overflow(
                overflowY = Overflow.Hidden,
                overflowX = Overflow.Auto
            )
            .minWidth(100.percent)
            .whiteSpace(WhiteSpace.NoWrap)
        .fillMaxSize()
    )
    {
        Box(modifier = Modifier
            .fillMaxSize()
            .overflow(Overflow.Auto)
            .padding(
                left =if (windowSizeMode!= WindowSizeModeEnum.Desktop)
                    0.px else Dimen.menuDefaultWidth,
            )
        ) {
            Box(
                modifier = Modifier
                    .overflow(Overflow.Auto)
                    .margin(bottom = Dimen.extraExtraLargeIconSize)
                    .fillMaxSize()
                    .onClick {
                        closeMenu()
                    }
            )
            {
                content()
            }

        }

        Column(
            modifier = Modifier
                .zIndex(Constants.ZIndex.largeZIndex)
                .position(Position.Fixed)
                .borderRight(
                    width =Dimen.smallThickness,
                    style = LineStyle.Solid,
                    color = Theme.ActionDisabledBackground.rgb,
                )
                .animatedWidth(
                    widthValue = if (isMenuExpandedHorizontally){
                        when(windowSizeMode){
                            WindowSizeModeEnum.Desktop-> Dimen.menuItemRowWidthDesktopAndTablet
                            WindowSizeModeEnum.TABLET->Dimen.menuItemRowWidthDesktopAndTablet
                            WindowSizeModeEnum.PHONE->Dimen.menuItemRowWidthPhone
                        }

                    }

                    else if(getNotExpandedWindowsMode(
                            windowSizeMode=windowSizeMode,
                            isMenuExpanded=isMenuExpandedHorizontally
                        )) 0.px else Dimen.menuDefaultWidth,
                    duration =
                    if(isFirstRender && !isMenuExpandedHorizontally) 0.0 else
                        Constants.fastExpandingTime,
                )
                .backgroundColor(Theme.White.rgb)
                .fillMaxHeight()
            , horizontalAlignment = if (isMenuExpandedHorizontally)
                Alignment.CenterHorizontally else Alignment.Start
        ) {

            MenuTopBar(
                windowSizeMode=windowSizeMode,
                applicationIcon =data.menuHeaderData.appIcon,
                titlePart1 = data.menuHeaderData.title1,
                titlePart2 = data.menuHeaderData.title2 ,
                isExpanded = isMenuExpandedHorizontally,
                backgroundColor = data.headerBackground,
                onMenuClick = {
                    changeMenuStatus()
                },
            )


            if(!getNotExpandedWindowsMode(
                    windowSizeMode=windowSizeMode,
                    isMenuExpanded=isMenuExpandedHorizontally
                ))
            {
                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .weight(1)
                        .height(Dimen.menuItemsHeight)
                        .styleModifier {
                            property("overflow-y", "auto")
                            property("::-webkit-scrollbar", "width: 0px;")
                            property("scrollbar-width", "none")
                        }
                        .backgroundColor(data.menuBackground)
                ){
                    Column (
                        modifier = Modifier
                            .fillMaxWidth()
                    )
                    {

                        data.menuItemsData.forEach { model ->
                            MenuItemRow(
                                itemTitle = model.title,
                                imgSrc = model.iconPath,
                                isMenuExpandedHorizontally=isMenuExpandedHorizontally,
                                subData = model.subData,
                                hoverColor = data.hoverColor,
                                clickedIconColor=data.clickedIconColor,
                                backgroundColor = data.clickedItemBackground,
                                isSelected =model==selectedItem,
                                onRowClick = {
                                    onMenuItemClick(model)
                                }
                            )
                        }

                    }
                }

            }


//            Footer(
//                data=data,
//                isExpanded = isMenuExpanded,
//                backgroundColor = data.footerBackground,
//                hoverColor = data.hoverColor,
//                clicked = clickedItemId==data.footerData.id,
//                onSettingRowClick = {
//                    clickedItemId=it
//                    onSettingClick()
//                },
//                onExitRowClick = {
//                    onExitClick()
//                }
//
//            )

        }





    }



}

private fun getNotExpandedWindowsMode(
    windowSizeMode: WindowSizeModeEnum,
    isMenuExpanded:Boolean):Boolean
{
    return windowSizeMode!= WindowSizeModeEnum.Desktop && !isMenuExpanded
}

